// extracted by mini-css-extract-plugin
export default {"mainContainer":"TopPart_mainContainer__82eqA","row":"TopPart_row__m1s-k","subtitle":"TopPart_subtitle__2OiLo","fontSize":"TopPart_fontSize__AnMeR"};